import { filterValueToQuery } from '@/api';

export default function itemRequest(axios: any) {
  async function getStockRequest() {
    try {
      const response = await axios.get('/api/stockRequests');
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/Suppliers] stockRequests Error', e);
    }
    return null;
  }
  async function getStockRequestView() {
    try {
      const response = await axios.get('/api/stockRequestView');
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/Suppliers] stockRequestView Error', e);
    }
    return null;
  }
  async function cancelStockRequest(id: number | string) {
    const response = await axios.put(`/api/cancelStockRequest/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/material] cancelStockRequest Error', e);
    }
    return null;
  }

  return {
    getStockRequest,
    cancelStockRequest,
    getStockRequestView,
  };
}
